export default __webpack_public_path__ + "img/cskAAxci.5ac598bd.svg";